import PropTypes from 'prop-types';
import { getFormattedNumber } from 'utils/clickme';

import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

const Overflow = ({ campaignId, overflow, apiSource }) => (
    <TableRow>
        <TableCell>{campaignId}</TableCell>
        <TableCell>{getFormattedNumber(overflow)}</TableCell>
        <TableCell>{apiSource}</TableCell>
    </TableRow>
);

Overflow.propTypes = {
    campaignId: PropTypes.number,
    overflow: PropTypes.number,
    apiSource: PropTypes.string,
};

export default Overflow;
